// @ts-nocheck
/* eslint-disable react/prop-types */
// LIBRARY
import React from 'react';
import { useState } from 'react';
import { Drawer, Form, Input, Button, Select, Switch, Row, Col, message } from 'antd';
import PropTypes from 'prop-types';
import {
	// Exam result Type Codes
	EITC_ALPHA_NUMERIC,
	EITC_NUMERIC,
	EITC_CHECKBOX,
	EITC_OPTION,
	EITC_TEXT_AREA,
} from 'global_config/constant-global';
import { AlphaNumInput, RegexInput, NumberInput } from 'shared_components/pattern_input';
import { createExamItem } from 'services/settings/examItem';
import { showMessage } from 'services/settings/message';
import { fetchUnitOfMeasureItems } from 'services/settings/lookup_table/unitOfMeasure';
import getInputTypeCode from 'services/settings/inputType';
import DynamicForm from '../dynamic_form';
import showIntegrationCodeModal from 'shared_components/integration_code_modal';
import { fieldRules, drawerTitle, fieldLabels, buttonNames } from '../settings';
import DynamicFormAnalyzer from '../dynamic_form_analyzer';

import './add_form.css';

const { Option } = Select;
const { TextArea } = Input;

class AddForm extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			isLoading: false,
			selectedRsType: null,
			unitOfMeasures: [],
			inputTypeCodes: [],
			analyzerDynamicForm: [],
			resetAnalyzerIsTrue: false,
		};

		this.formRef = React.createRef();
		this.dynamicForm = React.createRef();
	}

	async componentDidMount() {

		const unitOfMeasures = await fetchUnitOfMeasureItems();
		const activeUnitOfMeasures = (unitOfMeasures || []).filter(item => item.isActive === 1);
		const inputTypeCodes = await getInputTypeCode();
		this.setState({ unitOfMeasures: activeUnitOfMeasures, inputTypeCodes });
	}

	// for dynamic analyzer value
	handleAnalyzerValue = value => {
		this.setState({ analyzerDynamicForm: value });
	};


	onChangeItemTypeCode = itemTypeCode => {
		const { setFieldsValue } = this.formRef.current;
		if (itemTypeCode === EITC_NUMERIC) setFieldsValue({ examItemTypeDefault: '' });
		this.setState({ selectedRsType: itemTypeCode });
	};

	onSubmit = () => {
		const { selectedRsType, analyzerDynamicForm } = this.state;
		const { onSuccess, selectedSectionId, selectedSpecimenId, selectedExamItemList } = this.props;
		const { getFieldsValue } = this.formRef.current;

		const fields = getFieldsValue();
		const trimmedName = (fields.examItemName || '').trim().toLowerCase();

		// Duplicate Name Validation
		const isDuplicate = selectedExamItemList.some(
			item => item.examItemName.trim().toLowerCase() === trimmedName
		);

		if (isDuplicate) {
			message.info('Duplicate Exam Result Names are not allowed within the same SECTION and SPECIMEN');
			return;
		}

		// If checkbox or option get default & label in dynamic form
		if (selectedRsType === EITC_OPTION || selectedRsType === EITC_CHECKBOX) {
				const examItemValueParam = [];
				const checkKeys = this.dynamicForm.getCheckedItemKeys();
				const dynamicFields = this.dynamicForm.getFields();

				dynamicFields.forEach(item =>
					examItemValueParam.push({
						examItemValueDefault: checkKeys.includes(item.key) ? 1 : 0,
						examItemValueLabel: fields[`dynamicInputs_${item.key}`],
					}),
				);

				fields.examItemValue = examItemValueParam;
			}

			if (
				selectedRsType === EITC_ALPHA_NUMERIC ||
				selectedRsType === EITC_NUMERIC ||
				selectedRsType === EITC_TEXT_AREA
			) {
				if (fields.examItemTypeDefault) {
					fields.examItemValue = [
						{
							examItemValueDefault: 1,
							examItemValueLabel: fields.examItemTypeDefault,
						},
					];
				}
			}

			const maxSort = selectedExamItemList.reduce((max, item) => (item.examItemSort > max ? item.examItemSort : max), 0);
			const nextSort = maxSort + 1;

			///checking analyzer if is no data or null
			const analyzerCheck = analyzerDynamicForm.map(item => {
				const analyzerData =
					item.analyzerID === null && item.analyzerName === '' && item.examItemAnalyzerCode === '';
				return analyzerData;
			});
			const AnalyzerIsNull = analyzerCheck.includes(true);

			const payload = {
				examItemName: fields.examItemName,
				examItemGeneralName: fields.examItemGeneralName,
				examItemTypeCode: fields.examItemTypeCode,
				examItemIntegrationCode: fields.examItemIntegrationCode,
				examItemUnitCode: fields.examItemUnitCode,
				examItemValue: fields.examItemValue,
				sectionID: selectedSectionId,
				specimenID: selectedSpecimenId,
				active: fields.active === false ? 0 : 1,
				examItemSort: nextSort,
				examItemAnalayzereCodes: AnalyzerIsNull === true ? [] : analyzerDynamicForm,
			};

			showIntegrationCodeModal(fields.examItemIntegrationCode, {
				onConfirm: () => {
					this.setState({ isLoading: true }, async () => {
						const createdExamItem = await createExamItem(payload);
						this.setState({ isLoading: false });

						if (createdExamItem) {
							onSuccess();
							this.resetForm();
							this.resetAnalyzer();
						}
					});
				}
			});
	};

	resetAnalyzer = () => {
		this.setState({ analyzerDynamicForm: [], resetAnalyzerIsTrue: true });

		// set isTrue back to false after 0.5 milliseconds
		setTimeout(() => {
			this.setState({ resetAnalyzerIsTrue: false });
		}, 500);
	};

	resetForm = () => {
		// eslint-disable-next-line react/prop-types
		const { resetFields } = this.formRef.current;
		resetFields();
		this.setState({
			selectedRsType: null,
		});
	};

	onCancel = () => {
		const { onClose } = this.props;
		this.resetForm();
		this.resetAnalyzer();
		onClose();
	};

	render() {
		const {
			isLoading,
			selectedRsType,
			unitOfMeasures,
			inputTypeCodes,
			resetAnalyzerIsTrue,
		} = this.state;
		// eslint-disable-next-line react/prop-types
		const { onClose, visible, selectedSectionName, selectedSpecimenName } = this.props;

		const UnitMeasureOptions = unitOfMeasures.map(unit => {
			const code = unit.unitOfMeasureCode || unit.code || unit.Code;
			const base = unit.unitOfMesureBase || unit.unitOfMeasureBase || unit.base || unit.Base;
			const label = base ? `${code} - ${base}` : code;

			return (
				<Option value={code} key={code}>
					{label}
				</Option>
			);
		});

		const InputTypeCodeOptions = inputTypeCodes.map(typeCode => (
			<Option value={typeCode.inputTypeCode} key={typeCode.inputTypeCode}>
				{typeCode.inputTypeName}
			</Option>
		));

		return (
			<Drawer
				title={`${drawerTitle.add} - ${selectedSectionName} / ${selectedSpecimenName}`.toUpperCase()}
				width="50%"
				placement="right"
				closable
				onClose={this.onCancel}
				visible={visible}
			>
				<Form
					ref={this.formRef}
					onFinish={this.onSubmit}
					className="exam-item-add-form"
					layout="vertical"
					autoComplete="off"
				>
					<section style={{ marginBottom: 50 }}>
						<Form.Item name="active" valuePropName="checked" label="STATUS">
							<Switch defaultChecked disabled={true} />
						</Form.Item>
						<Row
							style={{
								display: 'flex',
								justifyContent: 'space-between',
							}}
						>
							<Form.Item
								name="examItemName"
								label={fieldLabels.examItemName}
								rules={fieldRules.examItemName}
								style={{ width: '32%' }}
							>
								<RegexInput regex={/[A-Za-z0-9 -]/} maxLength={200} width={200} />
							</Form.Item>
							<Form.Item
								name="examItemGeneralName"
								label={fieldLabels.examItemGeneralName}
								rules={fieldRules.examItemGeneralName}
								style={{ width: '32%' }}
							>
								<RegexInput regex={/[A-Za-z0-9 -]/} maxLength={50} />
							</Form.Item>

							<Form.Item
								name="examItemIntegrationCode"
								label={fieldLabels.examItemIntegrationCode}
								rules={fieldRules.integrationCode}
								style={{ width: '32%' }}
							>
								<Input maxLength={20} />
							</Form.Item>
						</Row>

						<Form.Item
							name="examItemTypeCode"
							label={fieldLabels.examItemTypeCode}
							rules={fieldRules.examItemType}
							style={{ width: '32%' }}
						>
							<Select onChange={this.onChangeItemTypeCode}>{InputTypeCodeOptions}</Select>
						</Form.Item>
						{selectedRsType === EITC_ALPHA_NUMERIC && (
							<div
								style={{
									display: 'flex',
									gap: '15px',
								}}
							>
								<Form.Item
									name="examItemUnitCode"
									label={fieldLabels.examItemUnitCode}
									rules={fieldRules.unitOfMeasure}
									style={{ width: '32%' }}
								>
									<Select allowClear>{UnitMeasureOptions}</Select>
								</Form.Item>
								<Form.Item
									name="examItemTypeDefault"
									label={fieldLabels.examItemTypeDefault}
									rules={fieldRules.examItemTypeDefault}
									style={{ width: '32%' }}
								>
									<AlphaNumInput maxLength={254} />
								</Form.Item>
							</div>
						)}
						{selectedRsType === EITC_NUMERIC && (
							<div
								style={{
									display: 'flex',
									gap: '15px',
								}}
							>
								<Form.Item
									name="examItemUnitCode"
									label={fieldLabels.examItemUnitCode}
									rules={fieldRules.unitOfMeasure}
									style={{ width: '32%' }}
								>
									<Select allowClear>{UnitMeasureOptions}</Select>
								</Form.Item>
								<Form.Item
									name="examItemTypeDefault"
									label={fieldLabels.examItemTypeDefault}
									rules={fieldRules.examItemTypeDefault}
									style={{ width: '32%' }}
								>
									<NumberInput maxLength={254} />
								</Form.Item>
							</div>
						)}
						{(selectedRsType === EITC_CHECKBOX || selectedRsType === EITC_OPTION) && (
							// @ts-ignore
							<DynamicForm
								ref={inst => (this.dynamicForm = inst)}
								allowMultipleDefaults={selectedRsType === EITC_CHECKBOX}
							/>
						)}
						{selectedRsType === EITC_TEXT_AREA && (
							<Form.Item
								name="examItemTypeDefault"
								label={fieldLabels.examItemTypeDefault}
								rules={fieldRules.examItemTypeDefault}
							>
								<TextArea maxLength={100} />
							</Form.Item>
						)}
						<DynamicFormAnalyzer
							handleAnalyzerValue={this.handleAnalyzerValue}
							handleExistingData={[]}
							resetAnalyzerIsTrue={resetAnalyzerIsTrue}
						/>
					</section>
					<section className="drawerFooter">
						<div>
							<Button shape="round" style={{ margin: 10, width: 120 }} onClick={this.onCancel}>
								{buttonNames.cancel}
							</Button>
							<Button
								shape="round"
								type="primary"
								htmlType="submit"
								loading={isLoading}
								style={{ margin: 10, width: 120 }}
							>
								{buttonNames.create}
							</Button>
						</div>
					</section>
				</Form>
			</Drawer>
		);
	}
}

AddForm.propTypes = {
	onClose: PropTypes.func.isRequired,
	visible: PropTypes.bool.isRequired,
	onSuccess: PropTypes.func.isRequired,
	selectedSectionId: PropTypes.number,
	selectedSpecimenId: PropTypes.number,
	selectedSectionName: PropTypes.string,
	selectedSpecimenName: PropTypes.string,
};

AddForm.defaultProps = {
	selectedSectionId: null,
	selectedSpecimenId: null,
	selectedSectionName: null,
	selectedSpecimenName: null,
};

export default AddForm;
